<section>
    <div *ngFor="let registro of historico; let i = index">
        <div class="row historico-container">
            <div class="status-container">
                <div class="col-12">
                    <div class="bullet"></div>
                    <span class="col-6 status-title">Status</span>
                    <span class="col-2 text-start update-title">Data e Hora de atualização</span>
                </div>
            </div>
            <div class="row informacoes-container">
                <div class="col-12 status-content">
                    <span class="col-6 status-badge" [ngClass]="{'active': i == 0, 'inactive': i > 0}">
                        {{ registro.estagioTriagemString }}
                    </span>
                    <span class="col-2 update-time">{{ registro.creationTime | date: 'dd/MM/YYYY \'às\' HH\'h\'mm'
                        }}</span>
                </div>
            </div>
        </div>
    </div>
</section>